// import axios from 'axios';
import axios from '../axios';

export default {
  login(email, password) {
    return axios.post(
      'users/sign_in',
      { user: { email, password } },
    );
  },
  logout() {
    return axios.delete('users/sign_out');
  },
  postPasswordForgotten(email) {
    return axios.post('users/password', { user: { email } });
  },
  postNewPassword(password, token) {
    return axios.put('users/password', { user: { password, reset_password_token: token } });
  },
};
